import { FaEdit } from "react-icons/fa";
import { Link } from "react-router-dom";
import { formatarDia } from "../../services/conversaoTimer";

function dataCredenciamento(participante) {
  const raw = participante?.created_at ?? participante?.createdAt;
  if (!raw) return "—";
  return formatarDia(String(raw));
}

const LinhaPatrocinador = ({ participante }) => {
  return (
    <tr>
      <td className="apl-cell-name">{participante?.nome || "—"}</td>
      <td>{participante?.nome_cracha || "—"}</td>
      <td className="apf-cell-email">{participante?.email || "—"}</td>
      <td>
        <span
          className="apl-stat apf-cell-date"
          title="Data em que o participante foi credenciado no sistema"
        >
          {dataCredenciamento(participante)}
        </span>
      </td>
      <td>
        <div className="apl-actions">
          <Link
            to={`/private/adm/convidados/editar/${participante.id}`}
            title="Editar participante"
          >
            <FaEdit size={12} aria-hidden />
            Editar
          </Link>
        </div>
      </td>
    </tr>
  );
};

export default LinhaPatrocinador;
